import script from "./NotificationMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationMessages.vue?vue&type=script&setup=true&lang=js"

import "./NotificationMessages.vue?vue&type=style&index=0&id=bd60ee8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd60ee8a"]])

export default __exports__